





























import Vue from 'vue'
import QuestionDialog from '@/components/QuestionDialog.vue'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'
import { MultiReportItemPayload, MultiReportPayload } from '@/types/payload'
import { GENERATE_MULTI_REPORT } from '@/store/action-types'

interface ComponentData {
  showSnackbar: boolean
  showSuccessSnackbar: boolean
  errorMessage: string
  successMessage: string
  showQuestionDialog: boolean
  questionDialogTitle: string
  questionDialogLabel: string
  loadingPDF: boolean
  loadingMail: boolean
  loadingPrintPDF: boolean
}

export default Vue.extend({
  name: 'AddressReportingFilter',

  components: {
    QuestionDialog
  },

  props: {
    addressId: {
      type: Number,
      default: undefined
    },

    selectedReportList: Array as () => any[]
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      showSuccessSnackbar: false,
      errorMessage: '',
      successMessage: '',
      showQuestionDialog: false,
      questionDialogTitle: '',
      questionDialogLabel: '',
      loadingPDF: false,
      loadingMail: false,
      loadingPrintPDF: false
    }
  },

  computed: {
    showSendEmailButton (): boolean {
      return securityService.isVisible(SecurityArea.Reports, SecurityComponent.SendEmailIcon)
    },

    isDisabledSendEmailButton (): boolean {
      return securityService.isDisabled(SecurityArea.Reports, SecurityComponent.SendEmailIcon)
    },
  },

  methods: {
    onPrintClick (): void {
      this.onGenerateReportClick(false, true)
    },

    async onGenerateReportClick (sendEmail: boolean, print: boolean): Promise<void> {
      const multiReportItemPayload: MultiReportItemPayload[] = this.selectedReportList.map((item: any) => {
        return {
          Report: item.reportLayout,
          ReportName: item.reportName,
          InputFilters: {
            Mitarbeiter: '',
            Mitarbeiter_Label: '',
            Abteilung: '',
            Abteilung_Label: '',
            Filiale: '',
            Filiale_Label: '',
            Filter: '',
            Filter_Label: '',
            Jahr: '',
            Jahr_Label: '',
            Von: '',
            Von_Label: '',
            Bis: '',
            Bis_Label: '',
            Farbe: '',
            Farbe_Label: '',
            KWdatumVon: '',
            KWdatumVon_Label: '',
            Monat: '',
            Monat_Label: '',
            Schichten: '',
            Schichten_Label: '',
            Grund: '',
            Grund_Label: '',
            Adresse: this.addressId.toString(),
            Adresse_Label: '',
            Planungsgruppe: '',
            Planungsgruppe_Label: '',
            SendTo: '',
            SendTo_Label: '',
          }
        }
      })

      const payload: MultiReportPayload = {
        AddressID: this.addressId,
        SendByEmail: sendEmail,
        LanguageId: 1,
        Reports: multiReportItemPayload
      }

        try {
          if(sendEmail) {
            this.loadingMail = true
          } else {
            if(print) {
              this.loadingPrintPDF = true
            } else {
              this.loadingPDF = true
            }
          }
          const response: any = await this.$store.dispatch(GENERATE_MULTI_REPORT, payload)
          this.loadingMail = false
          this.loadingPDF = false
          this.loadingPrintPDF = false
          if(!sendEmail) {
            if(response) {
              if(!print) {
                let pdfData = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(pdfData)
                let filename = response.headers['content-disposition'].split(';')[1].split('filename')[1].split('=')[1].trim()
                link.download = filename
                link.click()
              } else {
                let pdfData = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(pdfData)
                let filename = response.headers['content-disposition'].split(';')[1].split('filename')[1].split('=')[1].trim()
                link.download = filename
                let iframe = document.createElement('iframe');
                iframe.style.display = "none"
                iframe.src = window.URL.createObjectURL(pdfData)

                document.body.appendChild(iframe)
                if(iframe && iframe.contentWindow && iframe.contentWindow) {
                  iframe.contentWindow.focus()
                  iframe.contentWindow.print()
                }
              }
            } else {
              this.errorMessage = this.$t('reportingFilter.reportCouldNotBeGenerated').toString()
              this.showSnackbar = true
            }
          } else {
            if(response.data.IsError) {
              this.errorMessage = this.$t('reportingFilter.reportCouldNotBeGenerated').toString()
              this.showSnackbar = true
            } else {
              this.successMessage = this.$t('reportingFilter.emailDeliveryWasSuccessful').toString()
              this.showSuccessSnackbar = true
            }
          }
        } catch (e) {
          this.loadingMail = false
          this.loadingPDF = false
          this.loadingPrintPDF = false
          this.errorMessage = this.$t('reportingFilter.reportCouldNotBeGenerated').toString()
          this.showSnackbar = true
        }
    },

    onShowQuestionDialogClick (): void {
      this.questionDialogTitle = this.$t('reportingFilter.sendByEmail').toString()
      this.questionDialogLabel = this.$t('reportingFilter.doYouReallyWantToSendEmails').toString()
      this.showQuestionDialog = true
    },

    onQuestionDialogClose (): void {
      this.showQuestionDialog = false
    },

    onQuestionDialogSave (): void {
      this.showQuestionDialog = false
      this.onGenerateReportClick(true, false)
    }
  }

})
